import callKST from "./call";

// 快商通相关功能封装
export default class KST {

  // 调起快商通客服对话界面
  static call(text?: string, isMobile?: boolean) {
    callKST(text, isMobile);
  }
}